<template>
  <div class="Login-admin">
    <header-banner/>
    <div class="container">
      <div class="Common_form Login_form">
        <h2 class="title">{{ $t('login.admin.title', 'Admin Login') }}</h2>
        <form>
          <app-text-input
            :placeholder=" $t('login.admin.placeholder.username', 'Admin username')"
            v-model.trim="adminUserName"
            :errors="errorsFor('adminUserName')"
            data-name="login-email"
            :disabled="adminLoginTask.isActive"
          />
          <app-password-input
            :placeholder=" $t('login.admin.placeholder.password', 'Admin password')"
            v-model.trim="adminPassword"
            :errors="errorsFor('adminPassword')"
            data-name="login-password"
            :disabled="adminLoginTask.isActive"
          />
          <app-text-input
            :placeholder=" $t('login.admin.placeholder.customerEmail', 'Customer email')"
            v-model.trim="customerEmail"
            :errors="errorsFor('customerEmail')"
            data-name="login-customerEmail"
            :disabled="adminLoginTask.isActive"
          />
          <app-checkbox
            id="admin-login-terms"
            :label="$t('login.checkout.admin.text', 'I agree to log in to this user')"
            :value="agreeTerms"
            @input="agreeTerms = $event"
            @click="trackConversion({name: 'interaction', description: `agree_to_the_terms:${agreeTerms ? 'uncheck': 'check'}`})"
            data-name="admin-login-terms"
            :disabled="adminLoginTask.isActive"
          />
          <app-button
            type="submit"
            @click.prevent="adminLoginTask.run()"
            :is-loading="adminLoginTask.isActive"
            data-name="login-submitButton"
            :disabled="!agreeTerms"
          >
            {{ $t('login.button', 'Login') }}
          </app-button>
          <p class="link-wrapper">
            <router-link
              :to="{ name: 'login' }"
              class="link"
            >
              {{ $t('login.link.customerLogin', 'Customer login') }} ›
            </router-link>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import { getErrors, extractErrorMessage } from '@/utilities/common'
  import HeaderBanner from 'components/HeaderBanner'

  export default {
    name: 'login',

    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.updatePageName(to.meta.pageName)
      })
    },

    components: {
      HeaderBanner
    },

    data () {
      return {
        adminUserName: '',
        adminPassword: '',
        customerEmail: '',
        showValidations: false,
        agreeTerms: false
      }
    },

    validations: {
      adminUserName: {
        required
      },

      adminPassword: {
        required
      },

      customerEmail: {
        required
      }
    },

    methods: {
      errorsFor (field) {
        if (!this.showValidations) {
          return []
        }

        if (this.$v[field] == null) {
          return []
        }

        return getErrors(this.$v[field])
      }
    },

    tasks (t) {
      return {
        adminLoginTask: t(async function () {
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.showValidations = true
          } else {
            await this.$store.dispatch('account/loginAdmin', {
              customerEmail: this.customerEmail,
              adminUserName: this.adminUserName,
              adminPassword: this.adminPassword
            }).then(() => {
              this.$router.replace({ path: '/my-account' })
              window.localStorage.setItem('loginRole', 'admin')
            })
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('restart')
      }
    }
  }
</script>

<style lang="scss">
  .Login-admin {
    [data-name="login-customerEmail"] {
      margin-bottom: .15rem;
    }

    .Form_group-choice {
      margin-bottom: .15rem;
    }

    .HeaderBanner {
      @include media(tablet) {
        height: 3.49rem;
      }
    }

    .Login_form {
      margin-top: -.7rem;
      background-color: $body-bg;
    }

    .Re_form_group .Re_form_control {
      padding: .13rem .1rem;
      line-height: normal;
    }
  }
</style>
